import { SegmentedControllerProps, SegmentedControllerSegmentProps } from '@procore/core-react/dist/_typedoc/SegmentedController/SegmentedController.types.json';
import * as React from 'react';
export default {
  SegmentedControllerProps,
  SegmentedControllerSegmentProps,
  React
};